<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("edit") }} {{ $t("cash") }} {{ $t("card") }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Cash Cards' }"
        >{{ $t("cash") }} {{ $t("card") }} {{ $t("lists") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4" v-if="false">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                disabled
                id="cash_card_number"
                name="cash_card_number"
                v-validate="'required|max:16'"
                v-model="cash_card_number"
                placeholder="."
              />
              <label>{{ $t("card") }} {{ $t("number") }}</label>
            </div>
            <!-- <Tooltip :title="$t('cash_card_number')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('cash_card_number')">{{
              errors.first("cash_card_number")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2 pl-4">
          <div class="row">
            <!-- 3 8 1 -->
            <div class="col-md-2 mb-2 mr-1 p-0">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    id="prefix"
                    name="prefix"
                    v-model="prefix"
                    :disabled="true"
                    maxlength="3"
                    minlength="1"
                    placeholder="xxx"
                    type="text"
                    v-on:keydown="
                      (e) => {
                        if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                          e.preventDefault();
                        }
                      }
                    "
                  />
                  <label>{{ $t("prefix") }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-2 mr-1 p-0">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    id="randomIdentifier"
                    name="randomIdentifier"
                    v-model="randomIdentifier"
                    :disabled="true"
                    placeholder="xxxxxxxx"
                    type="text"
                    v-on:keydown="
                      (e) => {
                        if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                          e.preventDefault();
                        }
                      }
                    "
                  />
                  <label>{{ $t("random_card_number") }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-2 mb-2 mr-1 p-0">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    id="suffix"
                    name="suffix"
                    v-model="suffix"
                    :disabled="true"
                    placeholder="x"
                    maxlength="1"
                    type="text"
                    v-on:keydown="
                      (e) => {
                        if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                          e.preventDefault();
                        }
                      }
                    "
                  />
                  <label>{{ $t("suffix") }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-2 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
              style="text-align:right;"
                id="pin"
                name="pin"
                v-model="cash_card_pin"
                v-validate="'required'"
                placeholder="Enter Pin"
                maxlength="4"
                type="text"
                v-on:keydown="
                  (e) => {
                    if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                      e.preventDefault();
                    }
                  }
                "
              />
              <label>{{ $t("pin") }}</label>
            </div>
            <!-- <Tooltip :title="$t('Passcode')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('pin')"
              >{{ errors.first("pin") }}
            </span>
          </p>
        </div>

         <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="card_customer"
                :options="customers"
                :searchable="true"
                placeholder="Customer"
                label="temp_customer_name"
                track-by="track_id"
                @select="onSelectCustomer($event)"
                @remove="onRemoveCustomer($event)"
                :allowEmpty="false"
                :showLabels="false"
              >
               <span slot="noResult">Oops! No Results found.</span>
            <span slot="option" slot-scope="props"
              >{{ props.option.temp_customer_name }}<br><div class="tagEmail">{{props.option.hasOwnProperty('guest_id') ?props.option.guest_email : props.option.cust_email }}</div>
              <p class="tagText" v-if="props.option.guest_id">
                Guest
              </p></span
            >
              </multiselect>
            </div>
            <!-- <Tooltip :title="$t('selected_customer')" /> -->
          </div>
          <p class="error_message"></p>
        </div>


        <div class="col-lg-6 col-xl-2 mb-2">
          <div class="d-flex align-items-center pt-2 justify-content-end">

              <b-form-checkbox
                type="checkbox"
                class="j-checkbox pb-0"
                v-model="cash_card_is_active"
                true-value="Y"
                false-value="N"
                @change="OnChangeStatus()"
              />

            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            
          
              
            </label>
          </div>
        </div>


<div class="col-lg-6 col-xl-4 mb-2">
          <div class="row">
            <div class="col-10">
              <div class="d-flex align-items-center">
                <label
                  class="material-file-upload"
                  @click.prevent.stop="setModalData(637.5, 1011)"
                >
                  <div class="text-truncate p-2">
                    {{
                      cash_card_image ? cash_card_image : "Please Select Image"
                    }}
                  </div>
                </label>
                <!-- <Tooltip
                  :title="`Artwork to be displayed on Cash Card`"
                /> -->
              </div>
            </div>
            <div class="col-2 align-self-center">
              <ImagePreviewer :img="_GetImagePath(cash_card_image)" />
            </div>
          </div>
        </div>


       
        <!-- <div class="col-lg-6 col-xl-4 mb-4" v-if="is_guest_user == 'Y'">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                disabled
                id="guest_user_name"
                name="guest_user_name"
                v-model="guest_name"
                placeholder="."
              />
              <label>{{ $t("guest_user") }}</label>
            </div>
          </div>
        </div> -->

        <!-- <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
        <div class="input-material">
          <input
            disabled
            id="initial_amount"
            name="initial_amount"
            v-validate="'required|numeric'"
            v-model="initial_amount"
            placeholder="."
          />
          <label>Initial Amount</label>
        </div>
        <Tooltip :title="$t('initial_amount')" />
      </div>
      <p class="error_message">
          <span v-if="submitted && errors.has('initial_amount')">{{ errors.first('initial_amount') }}</span>
        </p>
        </div>-->

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
              style="text-align:right;"
                disabled
                id="remaining_balance"
                name="remaining_balance"
                v-model="balance"
                placeholder="."
              />
              <label>{{ $t("balance") }}</label>
            </div>
            <!-- <Tooltip :title="$t('remaining_balance')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('remaining_balance')">{{
              errors.first("remaining_balance")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="
                  amount_updated_by && amount_updated_by.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("updatedby") }}</label
              >
              <b-dropdown
                disabled
                :text="amount_updated_by"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(user, userIndex) in userList"
                  href="#"
                  :key="userIndex"
                  name="userDropdown"
                  id="userDropdown"
                  v-on:click="onSelectUser(user)"
                  >{{ user.first_name }} {{ user.last_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <!-- <Tooltip :title="$t('amount_updated_by')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && amount_updated_by.length == 0"
              >Please Select User</span
            >
          </p>
        </div>

        <div class="col-lg-12 mb-2">
          <div class="row">
            <div class="col-lg-6 col-xl-12">
              <div class="input-material-textarea">
                <textarea
                  id="remarks"
                  name="remarks"
                  v-model="remarks"
                  placeholder="."
                  rows="2"
                ></textarea>
                <label>{{ $t("remarks") }}</label>
              </div>
            </div>
          </div>
        </div>

        

        <div class="col-lg-6 col-xl-4 mb-2" v-if="checkStatus()">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="cash_card_reason"
                name="cash_card_reason"
                v-validate="checkStatus() ? 'required' : ''"
                v-model="cash_card_reason"
                placeholder="."
              />
              <label>{{ $t("cash_card_reason") }}</label>
            </div>
            <!-- <Tooltip :title="$t('cash_card_reason')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('cash_card_reason')">{{
              errors.first("cash_card_reason")
            }}</span>
          </p>
        </div>
      </div>

      <div class="text-center">
        <button @click="$bvModal.show('credit-debit')" class="btn-blue">
          {{ $t("add_money") }}/{{ $t("debit_cash") }}
        </button>
        <button @click.prevent.stop="editCashCard()" class="btn-blue">
          {{ $t("update") }}
        </button>
      </div>
      <div class="d-flex justify-content-between align-items-center my-2">
        <div class="d-flex"></div>
        <div class="d-flex align-items-center">
          <div class="mx-2">
            <b-dropdown name="listview" id="listview" variant="outline-blue">
              <template v-slot:button-content>
                {{ $t("viewing") }}&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp;
                <strong>{{ totalRows }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                v-if="list.name === 'All' || parseInt(list.name) < totalRows"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                href="#"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
      <div class="mt-2 table-scroll">
        <table class="list-view-table cash_card_logs mb-2" border="1">
          <thead class="text-center">
            <tr>
              <th>{{ $t("createdat") }}</th>
              <th>{{ $t("change") }} {{ $t("amount") }}</th>
              <th>{{ $t("amount_update_by") }}</th>
              <th>{{ $t("bookingCode") }}</th>
              <th>{{ $t("fnbOrder") }}</th>
              <th>{{ $t("closing_balance") }}</th>
              <th>{{ $t("remarks") }}</th>
            </tr>
          </thead>
          <tbody v-if="logList.length == 0">
            <tr>
              <td colspan="4">
                <h3 class="text-center">{{ "No records found" }}</h3>
              </td>
            </tr>
          </tbody>
          <tbody >
            <tr v-for="(log, logIndex) in logList" :key="logIndex" class="light_grey_back">
              <td class="">
                {{ log.log_created_at | dateParseYYYYMMDD }}
              </td>
              <td
                class="text-right"
                v-if="log.credit_amount"
                style="color: green"
              >
                {{ currencyData.curr_code }} {{ currFormat(log.credit_amount) }}
              </td>
              <td
                class="text-right"
                v-else-if="log.debit_amount"
                style="color: red"
              >
                -{{ currencyData.curr_code }} {{ currFormat(log.debit_amount) }}
              </td>
              <td class="text-right" v-else style="color: red">0.00</td>
              <td class="">{{ log.user_by || log.username || "-" }}</td>

              <td class="">
                {{ log.sb_booking_code ? log.sb_booking_code : "-" }}
              </td>
              <td class="">
                {{ log.order_code ? log.order_code : "-" }}
              </td>
              <td class="text-right">
                {{ currencyData.curr_code }}
                {{ currFormat(log.current_balance) }}
              </td>
              <td class="">{{ log.reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="logList.length > 0"
        class="d-flex justify-content-end mb-2 mx-3 align-items-center mt-2"
      >
        <div class="mr-2">{{ $t("export") }}:</div>
        <a
          :href="BASE_URL + `${this.reportUrl}${this.cash_card_id}`"
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
      <b-pagination
        v-if="totalRows > 0"
        v-model="currentPage"
        :total-rows="totalRows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
    <b-modal id="credit-debit" title="Credit/Debit" hide-header hide-footer>
      <div class="col-12 text-center mb-4 pb-2 mt-3">
        <h4>{{ $t("add_money") }}/{{ $t("debit_cash") }}</h4>
      </div>

      <div class="col-lg-12 col-xl-12 mb-1">
        <div class="d-flex align-items-center">
          <multiselect
            :options="['Add Cash', 'Deduct Cash']"
            v-model="selected_action"
            :searchable="true"
            placeholder="Select Action"
            :allowEmpty="false"
            :showLabels="false"
          ></multiselect>
        </div>
      </div>
      <div class="col-lg-12 col-xl-12 mt-4 mb-2">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <!-- @focus="onFocusHandler" -->
            <!-- :required="item.required" -->
            <input
              type="text"
              id="Amount"
              name="Amount"
              v-model="Amount"
              placeholder="."
              v-on:keydown="
                (e) => {
                  if (
                    !/[0-9]/.test(e.key) &&
                    e.keyCode !== 8 &&
                    e.keyCode !== 190
                  ) {
                    e.preventDefault();
                  }
                }
              "
            />
            <label>Amount</label>
          </div>
          <!-- <Tooltip :title="$t('subject')" />-->
        </div>
        <p class="error_message"></p>
      </div>

      <div class="col-lg-12 col-xl-12 mt-4 mb-2">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <!-- @focus="onFocusHandler" -->
            <!-- :required="item.required" -->
            <input
              type="text"
              id="reason"
              name="reason"
              v-model="CreditDebitReason"
              placeholder="."
            />
            <label>Reason</label>
          </div>
        </div>
        <p class="error_message"></p>
      </div>
      <div class="col-lg-12 col-xl-12 mb-1 text-center">
        <button @click.prevent.stop="updateBalance" class="btn-blue">
          {{ $t("update") }}
        </button>
        <button
          @click.prevent.stop="$bvModal.hide('credit-debit')"
          class="btn-blue"
        >
          Cancel
        </button>
      </div>
    </b-modal>
    <ImageGallery
      v-bind:propImageName="'Cash Card Artwork'"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
    ></ImageGallery>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";
import { mapGetters } from "vuex";
import ImageGallery from "@/components/Pages/ImageGallery/imageGalleryModal";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { generateRandomCode } from "@/helper/collection";
import ImagePreviewer from "@/components/Partials/ImagePreviewer.vue";

export default {
  components: { VueCropper, ImageGallery, ImagePreviewer },
  data() {
    return {
      is_guest_user: "N",
      guest_name: "",
      reportUrl: "/api/admin/export_cash_cards_logs/",
      currencyData: "",
      updateFlag: 0,
      Amount: 0,
      selected_action: "Add Cash",
      remaining_balance: null,
      set_height: null,
      set_width: null,
      showModal: false,
      cash_card_id: null,
      cash_card_image: "",
      cash_card_pin: null,
      cash_card_visible: null,
      cash_card_reason: "",
      cash_card_issuer: "",
      remarks: "",
      CreditDebitReason: "",
      prefix: null,
      randomIdentifier: null,
      suffix: null,
      submitted: false,
      cash_card_number: "",
      selected_customer: "",
      card_customer: "",
      customer_id: null,
      guest_id: null,
      initial_amount: null,
      amount_updated_by: "",
      user_id: null,
      cash_card_is_active: "Y",
      customerList: [],
      userList: [],
      logList: [],
      perPage: 10,
      currentPage: 1,
      totalRows: undefined,
      selectedvalue: 10,
      oldActiveStatus: "",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
    };
  },
  computed: {
    ...mapGetters(["finalImagePath"]),
    balance() {
      return parseFloat(this.remaining_balance).toFixed(2);
    },
    customers() {
      // this.customerList.forEach((x, index) => {
      //   x['track_id'] = `c-${index}`
      //   x['temp_customer_name'] = this.setLabel(x);
      // })
      return this.customerList
    },
    cashCardNumber() {
      let card_number = this.prefix + this.randomIdentifier + this.suffix;
      return card_number;
    },
    checkValidCardNumber() {
      if (
        this.prefix.length == 3 &&
        this.randomIdentifier.length == 8 &&
        this.suffix.length == 1
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    finalImagePath(newval) {
      console.log("newval", newval);
      this.cash_card_image = newval;
    },
  },
  mounted() {
    let user_id = this.secureStore.get("USINFO").user_id;
    this.getUserList(user_id);
    const { cash_card_id } = this.$route.params;
    if (cash_card_id) {
      this.cash_card_id = cash_card_id;
      this.getCashCard(cash_card_id);
      this.getCashCardLogs(cash_card_id);
      this.getCurrencyCode();
    } else {
      this.$router.go(-1);
    }
    //   this.getCustomerList()
    //   this.getUserList()
  },
  methods: {
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error :", error);
        });
    },
    OnChangeStatus() {
      this.cash_card_reason = "";
    },
    setModalData(height, width) {
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
    checkStatus() {
      if (this.oldActiveStatus == this.cash_card_is_active) {
        return false;
      } else {
        return true;
      }
    },
    setLabel(event) {
      let text = ``;
       if(event.hasOwnProperty('guest_id') && event.guest_id) {
text = `${event.guest_first_name && String(event.guest_first_name) !== 'null' ? event.guest_first_name : ""} ${
        event.guest_last_name && String(event.guest_last_name) !== 'null' ? event.guest_last_name : ""
      }`
       } else {
         text = `${event.first_name && String(event.first_name) !== 'null' ? event.first_name : ""} ${
        event.last_name && String(event.last_name) !== 'null' ? event.last_name : ""
      }`
       }
      return text;
    },
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
      } else {
        this.currentPage = event;
      }
      this.getCashCardLogs(this.cash_card_id);
    },
    getCashCardLogs: function (cash_card_id) {
      // let payload = {
      //   tableName: "cash_card_logs",
      //   cash_card_id: cash_card_id
      // };
      let loader = this.$loading.show();

      MarketingService.GetCashCardLogs({
        cash_card_id: cash_card_id,
        perPage: this.perPage,
        currentPage: this.currentPage,
      })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.data.length > 0) {
            this.logList = data.Records.data;
            if (data.Records.pagination.total) {
              this.totalRows = data.Records.pagination.total;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => setTimeout(() => loader.hide(), 1000));
    },
    updateBalance() {
      if (isNaN(this.Amount)) {
        this.$toasted.show("Please enter a valid amount.");
        return;
      } else if (this.Amount == 0) {
        this.$toasted.show("Please Enter Amount.");
        return;
      } else if (!this.CreditDebitReason && false) {
        this.$toasted.show("Please enter a valid Reason.");
        return;
      }
      if (this.selected_action == "Add Cash") {
        this.remaining_balance += +parseFloat(this.Amount).toFixed(2);
        this.updateFlag = 1;
        this.updateCashCardAmount();
        this.$bvModal.hide("credit-debit");
      } else if (this.selected_action == "Deduct Cash") {
        if (this.remaining_balance >= this.Amount) {
          this.remaining_balance -= +parseFloat(this.Amount).toFixed(2);
          this.updateFlag = 2;
          this.updateCashCardAmount();
          this.$bvModal.hide("credit-debit");
        } else {
          this.$toasted.show(
            "Debit Amount cannot be greater than Balance Amount"
          );
        }
      }
    },
    getCashCard: function (cash_card_id) {
      MarketingService.GetCashCard({ cash_card_id: cash_card_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            console.log("data.Records :>> ", data.Records);
            this.cash_card_id = data.Records[0].cash_card_id;
            this.is_guest_user = data.Records[0].guest_id ? "Y" : "N";
            this.guest_name = data.Records[0].guest_name || "";
            this.cash_card_number = data.Records[0].cash_card_number;
            this.cash_card_image = data.Records[0].cash_card_image;
            this.cash_card_visible = data.Records[0].cash_card_visible;
            let cardNumberArrayTemp =
              data.Records[0].cash_card_visible.split(" ");
            this.prefix = cardNumberArrayTemp[0] ? cardNumberArrayTemp[0] : "";
            this.randomIdentifier = cardNumberArrayTemp[1]
              ? cardNumberArrayTemp[1]
              : "";
            this.suffix = cardNumberArrayTemp[2] ? cardNumberArrayTemp[2] : "";
            this.cash_card_pin = data.Records[0].cash_card_pin;
            this.initial_amount = data.Records[0].initial_amount;
            this.remarks = data.Records[0].remarks;
            this.cash_card_issuer = data.Records[0].cash_card_issuer;
            this.remaining_balance = +parseFloat(
              data.Records[0].remaining_balance
            ).toFixed(2);
            this.cash_card_is_active = data.Records[0].cash_card_is_active;
            this.oldActiveStatus = data.Records[0].cash_card_is_active;
            this.getCustomerList(data.Records[0].customer_id);
            this.getGuestCustomers(data.Records[0].guest_id);
            // this.getUserList(data.Records[0].amount_updated_by)
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
     onRemoveCustomer(customer) {
       this.customer_id = null;
       this.guest_id = null;
       this.selected_customer = ''
    },
    onSelectCustomer(customer) {
      if(customer.hasOwnProperty('guest_id') && customer.guest_id) {
        this.selected_customer = `${
        customer.guest_first_name ? customer.guest_first_name : ""
      } ${customer.guest_last_name ? customer.guest_last_name : ""}`;

        this.guest_id = customer.guest_id
        this.customer_id = null;
      } else {
        this.selected_customer = `${
        customer.first_name ? customer.first_name : ""
      } ${customer.last_name ? customer.last_name : ""}`;
        
        this.customer_id = customer.cust_id;
        this.guest_id = null;
      }
    },
    onSelectUser(user) {
      this.amount_updated_by = `${user.first_name} ${user.last_name}`;
      this.user_id = user.user_id;
    },
     getGuestCustomers(guest_id) {
      let payload = {
        tableName: "guest_customers"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.customerList = this.customerList.concat(data.Records);
            this.customerList.map((x, index) => {
              x['temp_customer_name'] = this.setLabel(x);
              x['track_id'] = `c-${index}`;
              if (x.hasOwnProperty('guest_id') && x.guest_id == guest_id) {
                this.card_customer = x;
                this.selected_customer = `${x.guest_first_name} ${x.guest_last_name}`;
                this.guest_id = x.guest_id;
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCustomerList: function (customer_id) {
      let payload = {
        tableName: "customers",
        cust_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.customerList = this.customerList.concat(data.Records);
            this.customerList.map((x, index) => {
              x['temp_customer_name'] = this.setLabel(x);
              x['track_id'] = `c-${index}`;
              if (x.hasOwnProperty('cust_id') && x.cust_id == customer_id) {
                this.card_customer = x;
                this.selected_customer = `${x.first_name} ${x.last_name}`;
                this.customer_id = x.cust_id;
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getUserList: function (user_id) {
      let payload = {
        tableName: "users",
        is_active: "Y",
        user_id: user_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.userList = data.Records;
            this.userList.map((x) => {
              if (x.user_id == user_id) {
                this.amount_updated_by = `${x.first_name} ${x.last_name}`;
                this.user_id = x.user_id;
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    editCashCard() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();

          this.cash_card_visible =
            this.prefix + " " + this.randomIdentifier + " " + this.suffix;
          this.cash_card_number =
            this.prefix + this.randomIdentifier + this.suffix;
          let payload = {
            cash_card_id: this.cash_card_id,
            customer_id: this.customer_id,
            guest_id: this.guest_id,
            remarks: this.remarks,
            cash_card_image: this.cash_card_image,
            cash_card_pin: this.cash_card_pin,
            cash_card_number: this.cash_card_number,
            cash_card_visible: this.cash_card_visible,
            cash_card_is_active: this.cash_card_is_active,
          };
          // amount_updated_by: this.user_id,
          // updateFlag: this.updateFlag,
          // amount: this.Amount
          MarketingService.EditCashCard(payload)
            .then((response) => {
              const { data } = response;
              loader.hide();
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/marketing/cash-cards",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        } else {
          this.$toasted.show("Please enter all details");
        }
      });
    },
    updateCashCardAmount() {
      if (this.checkValidCardNumber) {
        let loader = this.$loading.show();

        let payload = {
          cash_card_id: this.cash_card_id,
          cash_card_number: this.cashCardNumber,
          remaining_balance: this.remaining_balance,
          amount_updated_by: this.user_id,
          updateFlag: this.updateFlag,
          reason: this.CreditDebitReason,
          amount: this.Amount,
        };
        MarketingService.UpdateCashCardAmount(payload)
          .then((response) => {
            const { data } = response;
            loader.hide();
            if (data && data.status) {
              this.$toasted.show(data.message);
              this.getCashCardLogs(this.cash_card_id);
              this.CreditDebitReason = "";
              this.Amount = 0;
              // this.$router.push({
              //   path: "/marketing/cash-cards"
              // });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      } else {
        this.$toasted.show("Invalid Card Number");
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.totalRows;
        this.selectedvalue = this.totalRows;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
  },
};
</script>
<style >
.cash_card_logs tbody td {
  padding: 11px !important;
}

.tagText {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 10px !important;
}
.tagEmail {
  font-size: 9px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CashCardComponents/editCashCard.vue